import styled from "@emotion/styled";
import { ArrowDownIcon } from "@smartsheet/lodestar-icons";
import { ChevronDownIcon } from "@smartsheet/ursa-icons";
import React from "react";
import { useCombinedThemeMode } from "../../../../util/theme/useCombinedThemeMode";

const ToggleButtonLodestar = styled(ArrowDownIcon)`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    position: relative;
    top: -2px;
    left: -2px;
`;

const ToggleButtonWrapper = styled("span")`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    margin: -4px;
    height: 20px;
    width: 20px;
`;

export const ToggleButtonIcon = () => {
    const themeMode = useCombinedThemeMode();
    return (
        <ToggleButtonWrapper>
            {(() => {
                switch (themeMode) {
                    case "ursa-light":
                        return <ChevronDownIcon size={20} />;
                    case "lodestar-light":
                    case "oldestar":
                        return <ToggleButtonLodestar />;
                }
            })()}
        </ToggleButtonWrapper>
    );
};
